// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1k8wR","left":"styles_left__1xL9D"};